import "./Book.css"

const Book = () => {
  return (
    <>
    <div className="book">
       
        <img src="https://www.freepnglogos.com/uploads/youtube-play-red-logo-png-transparent-background-6.png" alt="" />
    <span>PROVIDE SERVICE FOR </span>
    <span>BUILD YOUR BODY</span>
    <label className="strokepart">Gym Video</label>
    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. the readable content of a page when looking at its layout.</p>
    
    <div className="booknow">
        <button className="bookbtn">--- Book a Class</button>
        <button className="callbtn">--- Call us:+91 1234-568799 </button>
    </div>
    
    </div>
    
    
    </>
  )
}

export default Book
